<template>
  <button type="button" class="btn btn-tertiary absolute rounded-full p-2">
    <CloseIcon class="h-4 w-4" />
  </button>
</template>

<script>
import CloseIcon from '@/assets/svg/icons/x.svg?inline'

export default {
  components: { CloseIcon },
}
</script>
